module.exports = __webpack_public_path__ + "static/media/wsp_icon.e567ec2c.svg";